import { createStyles, Theme, withStyles, Box, BoxProps } from "@material-ui/core";

export const BlockWrapper = ({ children, ...props }: BoxProps) => {
  return <Block {...props}>{children}</Block>;
};

export const Block = withStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: theme.spacing(2),
      borderRadius: 4,
      backgroundColor: "rgba(247, 247, 247, 0.5)",
      padding: "0 20px 24px",
    },
  }),
)(Box);
